/**
 * The stored (tokenless) download link of a survey photo, built from its storage path: the SAME string the server derives and
 * persists (functions/src/survey/services/surveyIntakeService.ts downloadUrlFor), so what the client records and what the server keeps
 * cannot differ.
 *
 * Why this and not `getDownloadURL`: survey photos are uploaded by signed link and carry no download token. `getDownloadURL` on such an
 * object makes the Storage backend MINT and PERSIST a permanent bearer token the first time it is asked, a link that works for anyone who
 * holds the string, forever, and that storage.rules cannot gate. Survey photos are shown by reading their bytes (see
 * @officehub/survey-capture SurveyPhotoImage), so no link is ever needed. The callables ignore the url field they are sent and derive it
 * themselves; survey_addIntakePhoto still requires it to be non-empty, which is why it is sent.
 */
export function storedSurveyPhotoUrl(storageRef: string): string {
  const bucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
  if (!bucket) throw new Error('REACT_APP_FIREBASE_STORAGE_BUCKET is not set');
  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(storageRef)}?alt=media`;
}
